import { DocumentacionPEXENTITY } from 'sigo-entities'
import { DtoTrabajosDE } from '../../../../Trabajos/Domain/DtoTrabajosDE'
import { UpdateNodosDocDP } from 'sigo-package'

export const generarModeloDocZanja = (documentacion: DocumentacionPEXENTITY, trabajo: DtoTrabajosDE) => {
  return UpdateNodosDocDP<DocumentacionPEXENTITY>({ documentacion, obra: trabajo.ColeccionObras[0], trabajo })
}